import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface ReportTableProps {
  title: string;
  columns: string[];
  rows: ReactNode[][];
  emptyMessage?: string;
  numericColumns?: number[];
  footer?: ReactNode;
}

export const ReportTable = ({
  title,
  columns,
  rows,
  numericColumns = [],
  footer,
  emptyMessage = "No data for selected filters.",
}: ReportTableProps) => (
  <Card className="gap-3 py-4">
    <CardHeader className="pb-0">
      <CardTitle className="text-base">{title}</CardTitle>
    </CardHeader>
    <CardContent>
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column, index) => (
              <TableHead key={column} className={numericColumns.includes(index) ? "text-right" : undefined}>{column}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <TableRow key={`${title}-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <TableCell key={`${title}-${rowIndex}-${cellIndex}`} className={numericColumns.includes(cellIndex) ? "text-right tabular-nums whitespace-nowrap" : undefined}>{cell}</TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center text-muted-foreground">
                {emptyMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {footer && <div className="mt-4">{footer}</div>}
    </CardContent>
  </Card>
);
